export const GET_DELIVERY_BOYS = "GET_DELIVERY_BOYS";
export const DELIVERY_LOADING = "DELIVERY_LOADING";
